import React from "react";

import "flickity/dist/flickity.min.css";
import Flickity from "flickity/dist/flickity.pkgd.min";
import PropTypes from "prop-types";

import ProjectCell from "./ProjectCell";

export default class ProjectsCarousel extends React.Component {
  static propTypes = {
    options: PropTypes.array,
    projects: PropTypes.arrayOf(
      PropTypes.shape({
        slug: PropTypes.string,
        name: PropTypes.string,
        date: PropTypes.string,
        subtitle: PropTypes.string,
        description: PropTypes.string,
        video: PropTypes.string,
        organization: PropTypes.string,
        tags: PropTypes.arrayOf(PropTypes.string),
        github: PropTypes.string,
        link: PropTypes.string,
        people: PropTypes.number
      })
    ).isRequired
  };

  ref = undefined;
  carousel = undefined;

  componentWillUpdate() {
    if (this.carousel) this.carousel.destroy();
  }

  componentDidUpdate() {
    this.carousel = new Flickity(this.ref, this.props.options);
    this.carousel.resize();
  }

  componentDidMount() {
    this.carousel = new Flickity(this.ref, this.props.options);
    window.addEventListener("load", () => {
      this.carousel.resize();
    });
  }

  componentWillUnmount() {
    this.carousel.destroy();
  }

  render() {
    const { projects } = this.props;

    return (
      <div className="carousel" ref={ref => (this.ref = ref)}>
        {projects.map(p => (
          <ProjectCell project={p} key={p.slug} />
        ))}
      </div>
    );
  }
}
